module.exports = __webpack_public_path__ + "img/adset-icon.6b7c5530.svg";